import { organizations } from 'locales/ja/organizations';
import type { PageType } from 'types/page_type';

const currentYear = new Date().getFullYear();
export const copyright = `© 2018 - ${currentYear} SIGNATE Inc.`;

export const signInPage: Readonly<PageType> = {
  path: '/sign_in',
  title: 'サインイン',
  description: 'SIGNATE Cloud 組織管理画面へのサインイン',
};

export const signInAzureSamlPage: Readonly<PageType> = {
  path: `${signInPage.path}/azure_saml`,
  title: 'サインイン',
  description: 'Azure AD 経由で SIGNATE Cloud 組織管理画面へのサインイン',
};

export const signInOktaSamlPage: Readonly<PageType> = {
  path: `${signInPage.path}/okta_saml`,
  title: 'サインイン',
  description: 'Okta 経由で SIGNATE Cloud 組織管理画面へのサインイン',
};

export const signInOrganizationsPage: Readonly<PageType> = {
  path: `${signInPage.path}/organizations`,
  title: `${organizations.resourceName}の選択`,
  description: '管理する対象の組織を選択',
};
